import { render } from "./EmailBlacklist.vue?vue&type=template&id=86cb0670"
import script from "./EmailBlacklist.vue?vue&type=script&lang=js"
export * from "./EmailBlacklist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__